import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const interstitialInfo = 'interstitial_banner';

export const useInterstitialPopupAnalytics = () => {
  const trackInterstitialPopupShow = useCallback(() => {
    TrackingApi.trackInterstitial({
      info: interstitialInfo,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackInterstitialPopupClose = useCallback(() => {
    TrackingApi.trackInterstitial({
      info: interstitialInfo,
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackInterstitialPopupClick = useCallback((parameter: string) => {
    TrackingApi.trackInterstitial({
      info: interstitialInfo,
      operation: 'click',
      parameter,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackInterstitialPopupShow,
    trackInterstitialPopupClose,
    trackInterstitialPopupClick,
  };
};
